import React, { FunctionComponent } from 'react';

import { MongoEvent } from 'interfaces/events.interface';
import TimelineEvent from '../timeline-event';
import { getBilikUserName } from 'utils/get-bilik-username';
import { PhoneNumber } from 'utils';

type Props = {
  event: MongoEvent;
};

const StopSmsCreated: FunctionComponent<Props> = ({ event }) => {
  return (
    <TimelineEvent
      date={event.date}
      icon="mobile alternate"
      color="red"
      title="Sms automatiques désactivés"
      initiator="bilik-user"
      bilikUserName={getBilikUserName(event.initiator.bilik)}
    >
      <h3>
        <span>
          {event.initiator.bilik.givenName} {event.initiator.bilik.familyName}
        </span>{' '}
        a désactivé l&apos;envoi de sms automatiques pour le :{' '}
        {PhoneNumber.format(event.data.stopSms.telephone)}
      </h3>
    </TimelineEvent>
  );
};

export default StopSmsCreated;
